export interface AppSettings {
  navPos?: 'side' | 'top';
  dir?: 'ltr' | 'rtl';
  sidenavOpened?: boolean;
  sidenavCollapsed?: boolean;
  language?: string;
}

export const defaults: AppSettings = {
  navPos: 'side',
  dir: 'ltr',
  sidenavOpened: true,
  sidenavCollapsed: false,
  language: 'en-US',
};
